import React, { useEffect, useRef, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { customReactSelectStyles } from "./medication-select";

const DosageSelect = ({
  onChange = () => {},
  selectedMedicine = {
    doseOptions: [],
    dose: null,
    formOptions: [],
    form: null,
    routeOptions: [],
    route: null,
  },
  isRequired = false, // Add the new prop here
  error = false,
  value: actualValue = { value: "", label: "" },
  subType = '',
  isDisabled = false,
}) => {
  // Prepare options based on conditions

  let defaultOptions = [];
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(defaultOptions);
  const [value, setValue] = useState(null);
  const [showError, setShowError] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const editingLabelRef = useRef(null);
  const editingValueRef = useRef(null);

  useEffect(() => {
    const { doseOptions, dose } = selectedMedicine;
    if (doseOptions && doseOptions.length > 0 && !dose) {
      defaultOptions = doseOptions.map((option) => ({
        label: option,
        value: option ,
      }));
      setValue(null);
      SetShowError(true);
    } else if (dose && doseOptions?.length > 0) {
      defaultOptions = [
        { label: dose, value: dose  },
        ...doseOptions.map((option) => ({
          label: option,
          value: option,
        })),
      ];
      setValue(defaultOptions[0]);
      setShowError(false);
      onChange(defaultOptions[0]);
    }else if (dose) {
      defaultOptions = [
        { label: dose, value: dose  },
      ];
      setValue(defaultOptions[0]);
      setShowError(false);
      onChange(defaultOptions[0]);
    } 
     else {
      defaultOptions = [];
      
    }
    let subTypeDefaultOptions = [
      {
        label:'Use as directed',
        value:'Use as directed'
      },
      {
        label:'Use as directed, see comments',
        value:'Use as directed, see comments'
      }
    ];
    if(subType) {
      setOptions([...subTypeDefaultOptions,...defaultOptions])
    }
    else {
      setOptions(defaultOptions);
    }
  }, [selectedMedicine,subType]);

  const handleCreate = (inputValue) => {
    const replacingLabel = editingLabelRef.current;
    editingLabelRef.current = null;
    editingValueRef.current = null;
    setIsLoading(true);
    setTimeout(() => {
      const newOption = {
        label: inputValue,
        value: inputValue,
        __isCustom: true,
      };
      setIsLoading(false);
      setOptions((prevOptions) => {
        const filtered = replacingLabel
          ? prevOptions.filter((o) => o.value !== replacingLabel)
          : prevOptions;
        return [...filtered, newOption];
      });
      setValue(newOption);
      setInputValue("");
      setShowError(isRequired && !newOption);
      onChange(newOption);
    }, 300);
  };

  const handleBlur = () => {
    if (isRequired && !value) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  };

  useEffect(() => {
    if (actualValue?.value) {
      setValue(actualValue);
    } else {
      setValue(null);
    }
  }, [actualValue]);

  useEffect(() => {
    if (error) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [error]);

  return (
    <div className="w-full col-span-4">
      <div
        className={`relative rounded-[4px] border-[1px] ${
          showError ? "border-red-200" : "border-gray-100"
        } ${isDisabled ? 'pointer-events-none opacity-70': ''} ${!isDisabled && isRequired && value === null ? "bg-blue-100" : "bg-white"} px-3 py-3 focus-within:border-REELTeal focus-within:border-[2px]`}
      >
        {" "}
        <div className="">
          <span className="block mb-1 text-gray-900 text-body-xs">
            Dosage {isRequired && <span className="">*</span>}
          </span>
          <CreatableSelect
            isClearable
            styles={customReactSelectStyles(isRequired, value)}
            isDisabled={isLoading || isDisabled}
            isLoading={isLoading}
            onChange={(newValue) => {
              setValue(newValue);
              setInputValue("");
              editingLabelRef.current = null;
              editingValueRef.current = null;
              setShowError(isRequired && !newValue);
              onChange(newValue);
            }}
            onCreateOption={handleCreate}
            onBlur={handleBlur}
            options={options}
            value={value}
            inputValue={inputValue}
            onInputChange={(val, action) => {
              if (action?.action !== "input-blur" && action?.action !== "menu-close") {
                setInputValue(val);
              }
            }}
            onMenuOpen={() => {
              if (value?.__isCustom) {
                editingLabelRef.current = value.label;
                editingValueRef.current = value;
                setInputValue(value.label);
                setValue(null);
              }
            }}
            onMenuClose={() => {
              if (editingLabelRef.current && editingValueRef.current) {
                setValue(editingValueRef.current);
                setInputValue("");
              }
            }}
            formatCreateLabel={(inputVal) =>
              editingLabelRef.current ? `Update to"${inputVal}"` : `Create "${inputVal}"`
            }
            filterOption={(option, inputStr) => {
              // While editing a custom value show all options unfiltered
              if (editingLabelRef.current) return true;
              return option.label.toLowerCase().includes(inputStr.toLowerCase());
            }}
            placeholder="Select dosage"
            className="col-span-4"
          />
        </div>
      </div>
      {showError && (
        <span className="block mt-1 text-red-200 text-body-xs">
          Dosage is required
        </span>
      )}
    </div>
  );
};

export default DosageSelect;
